
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class SwitchButton extends Vue {
  @Prop({ default: undefined })
  value!: //绑定值
  boolean | number | string;

  @Prop({ default: undefined, type: [Boolean, Number, String] })
  okValue!: //开启值
  boolean | number | string;

  @Prop({ default: undefined, type: [Boolean, Number, String] })
  noValue!: //关闭值
  boolean | number | string;

  @Prop({ default: false, type: Boolean }) disabled!: boolean; //禁用
  @Prop({ default: "big" }) size!: string; //big small

  valueType = ""; //绑定值的类型
  //组件内使用的值
  useValue = false;
  useOkValue: boolean | number | string = true;
  useNoValue: boolean | number | string = false;

  @Watch("value")
  onValueChange() {
    this.formatValue();
  }

  created() {
    if (this.value === undefined) {
      throw new Error("Switch未传值");
    }
    const t = typeof this.value;
    console.log(this.value, "->type:" + t);
    this.valueType =
      t === "boolean"
        ? "boolean"
        : t === "number"
        ? "number"
        : t === "string"
        ? "string"
        : "";
    this.formatValue(); //处理值  组件内转成boolean使用
  }

  mounted() {
    // console.log(a);
  }
  formatValue() {
    //无声明则 默认对应关系 boolean-> true false ; number-> 1 2;  string->  "1" "";
    if (this.valueType === "boolean") {
      this.useOkValue = this.okValue === undefined ? true : this.okValue;
      this.useNoValue = this.noValue === undefined ? false : this.noValue;
    } else if (this.valueType === "number") {
      this.useOkValue = this.okValue === undefined ? 1 : this.okValue;
      this.useNoValue = this.noValue === undefined ? 2 : this.noValue;
    } else if (this.valueType === "string") {
      this.useOkValue = this.okValue === undefined ? "1" : this.okValue;
      this.useNoValue = this.noValue === undefined ? "" : this.noValue;
    } else {
      throw new Error("Switch入值错误");
    }
    this.useValue = this.value === this.useOkValue ? true : false;
    console.log(this.useValue);
    console.log(this.useOkValue);
    console.log(this.useNoValue);
  }

  returnValue() {
    return this.useValue ? this.useOkValue : this.useNoValue;
  }

  /*   
  @beforeChange="beforeChange"
  beforeChange(value: any, callback: (arg: boolean) => void) {
    //do something...
    callback( true/false);
  } */
  //改变前校验  父级回调用法 ⏫
  beforeChange() {
    let res = true;
    this.$emit("beforeChange", this.returnValue(), (val: boolean) => {
      if (![true, false].includes(val)) return;
      res = val;
    });
    return res;
  }

  /*   @input="input"
   */
  //改值  父级除改值以外若要回调 用@input
  change() {
    if (this.disabled) return;
    if (!this.beforeChange()) return;
    this.useValue = !this.useValue;
    this.$emit("input", this.returnValue());
  }
}
